<template>
  <div class="table-header table-staffing">
    <div class="dt-content">
      <div class="dt-header" id="dt-header">
        <div class="header-col padding-left-27px"
             :style="{ width: columnWidth.firstName.size ? (columnWidth.firstName.size + 'px') : '10%' }"
             @click="setSortOption('firstName')" id="firstName">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('firstName', $event)"></div>
              <div class="content no-select">
                first name
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'firstName'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'firstName' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'firstName' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.lastName.size ? (columnWidth.lastName.size + 'px') : '10%' }"
             @click="setSortOption('lastName')" id="lastName">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('lastName', $event)"></div>
              <div class="content no-select">
                last name
                <span>
                <Icon name="sort" class="sort-icon"
                      v-if="this.pagingObj.sortType != 'lastName'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'lastName' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'lastName' && !this.pagingObj.sortReverse"></Icon>
              </span>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.email.size ? (columnWidth.email.size + 'px') : '16%' }"
             @click="setSortOption('email')" id="email">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('email', $event)"></div>
              <div class="content no-select">
                email
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'email'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'email' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'email' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.phoneNumber.size ? (columnWidth.phoneNumber.size + 'px') : '8%' }"
             @click="setSortOption('phone')" id="phoneNumber">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('phoneNumber', $event)"></div>
              <div class="content no-select">
                phone number
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'phone'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'phone' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'phone' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.role.size ? (columnWidth.role.size + 'px') : '14%' }"
             @click="setSortOption('role')" id="role">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('role', $event)"></div>
              <div class="content no-select">
                role
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'role'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'role' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'role' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.events.size ? (columnWidth.events.size + 'px') : '10%' }"
             @click="setSortOption('events')" id="events">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('events', $event)"></div>
              <div class="content no-select">
                events
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'events'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'events' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'events' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.events.size ? (columnWidth.payRates.size + 'px') : '8%' }"
             @click="setSortOption('payRates')" id="payRates">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('payRates', $event)"></div>
              <div class="content no-select">
                hourly rate
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'payRates'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'payRates' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'payRates' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.events.size ? (columnWidth.address.size + 'px') : '20%' }"
             @click="setSortOption('address')" id="address">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('address', $event)"></div>
              <div class="content no-select">
                address
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'address'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'address' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'address' && !this.pagingObj.sortReverse"></Icon>
              </div>
            </div>
          </div>
        </div>
        <div class="header-col" :style="{ width: columnWidth.actions.size ? (columnWidth.actions.size + 'px') : '4%' }"
             id="actions">
          <div class="header-container">
            <div class="crop">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/sort';
  import 'vue-awesome/icons/sort-up';
  import 'vue-awesome/icons/sort-down';
  import Icon from 'vue-awesome/components/Icon';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import * as _ from 'lodash';

  export default {
    name: 'table-header',
    components: {
      Icon
    },
    props: {
      pagingObj: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {}
    },
    computed: {
      ...mapGetters({
        columnWidth: 'GETTER_GET_COLUMN_TABLE_STAFFING'
      })
    },
    methods: {
      setSortOption (sortType) {
        if (!this.resizing) {
          this.pagingObj.sortType = sortType;
          this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
          this.$emit('CHANGE_PAGING_OPTIONS', this.pagingObj);
        }
      },
      changeColumnWidth: function (colName, mouseDownEvent) {
        this.resizing = true;
        let vueApp = this;
        // get current mouse position
        let shiftX = mouseDownEvent.clientX;
        // header width
        let dtHeaderEl = document.getElementById('dt-header');
        let headerWidth = dtHeaderEl.getBoundingClientRect().width;
        // get maximum width
        let maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
        let newWidth = maxLeft;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);

        function onMouseMove (event) {
          // new position
          let bufferPx = event.clientX - shiftX;
          let newHeaderWidth = headerWidth + bufferPx;

          if (bufferPx < 0 && (maxLeft - Math.abs(bufferPx)) < 20) {
            newWidth = 20;
            newHeaderWidth = headerWidth - (maxLeft - 20);
          } else {
            newWidth = maxLeft + bufferPx;
          }

          // save data
          vueApp.saveColumnWidthStaffing({
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: colName,
            newWidth: newWidth.toFixed(2)
          }, true);
        }

        function onMouseUp () {
          document.removeEventListener('mouseup', onMouseUp);
          document.removeEventListener('mousemove', onMouseMove);
          setTimeout(() => {
            vueApp.resizing = false;
          }, 50);
        }
      },
      saveDefaultColumnWidth (isWidthPercent) {
        let dtHeaderEl = document.getElementById('dt-header');
        let headerWidth;
        if (dtHeaderEl) {
          headerWidth = dtHeaderEl.getBoundingClientRect().width;
        }
        let arrCol = [
          {
            colName: 'firstName',
            newWidth: 140
          },
          {
            colName: 'lastName',
            newWidth: 140
          },
          {
            colName: 'email',
            newWidth: 160
          },
          {
            colName: 'phoneNumber',
            newWidth: 140
          },
          {
            colName: 'role',
            newWidth: 140
          },
          {
            colName: 'events',
            newWidth: 140
          },
          {
            colName: 'payRates',
            newWidth: 90
          },
          {
            colName: 'address',
            newWidth: 160
          },
          {
            colName: 'actions',
            newWidth: 140
          }
        ];
        // let newHeaderWidth = isWidthPercent ? document.body.clientWidth - 30 : 1000;
        let newHeaderWidth = headerWidth < 1200 ? 1200 : headerWidth;
        arrCol.forEach((element) => {
          let objResize = {
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: element.colName,
            newWidth: isWidthPercent ? 0 : element.newWidth,
            isWidthPercent: isWidthPercent
          };
          if (isWidthPercent) {
            this.mutationSaveColumnWidthStaffing(objResize);
            let tbHeaderId = 'dt-header';
            let tbBodyId = 'dt-body';
            let dtHeaderEl = document.getElementById(tbHeaderId);
            let dtBodyEl = document.getElementById(tbBodyId);
            if (dtHeaderEl) {
              dtHeaderEl.style.width = 'unset';
            }
            if (dtBodyEl) {
              dtBodyEl.style.width = 'unset';
            }
          } else {
            this.saveColumnWidthStaffing(objResize);
          }
        })
      },
      ...mapActions({
        saveColumnWidthStaffing: 'ACTION_SAVE_COLUMN_STAFFING_WIDTH'
      }),
      ...mapMutations({
        mutationSaveColumnWidthStaffing: 'MUTATION_SAVE_COLUMN_STAFFING_WIDTH'
      })
    },
    mounted () {
      if (document.body.clientWidth < 1200) {
        this.saveDefaultColumnWidth();
      }
    },
    created () {
      window.addEventListener('resize', _.debounce((event) => {
        if (document.body.clientWidth < 1200) {
          this.saveDefaultColumnWidth();
        } else {
          this.saveDefaultColumnWidth(true);
        }
      }, 100));
    }
  }
</script>

<style lang="less">
  @import '../../styles/variables.less';

  .table-header.table-staffing {
    color: @grey-7;
    font-family: @font-family-main;
    font-size: 12px;
    letter-spacing: 0.1px;
    // line-height: 16px;
    .dt-content {
      .dt-header {
        .text-center {
          text-align: center;
        }
        .header-col {
          float: left;
          text-transform: uppercase;
          overflow: hidden;
          height: 33px;

          .content {
            margin-top: 12px;
            margin-left: 8px;
          }
          .sort-icon {
            vertical-align: middle;
            width: 6px;
            height: 10px;
            margin: 5px;
          }
          .header-container {
            position: relative;
          }
          .crop {
            // height: 37px;
            transition: all 0.25s;
            cursor: pointer;
          }

          .crop .crop-line {
            position: absolute;
            transition: all 0.25s;
          }
          .crop:hover .crop-line {
            border-color: @grey-3;
          }
          .crop .crop-top-line {
            top: 0;
            left: 0;
            right: 0;
            border-top: 1px solid @grey-3;
            cursor: n-resize;
            height: 16px;
          }
          .crop .crop-bottom-line {
            bottom: 0;
            left: 0;
            right: 0;
            height: 5px; /* 5px for the mouse cursor update size */
            border-bottom: 1px solid @grey-3;
            cursor: s-resize;
          }
          .crop .crop-left-line {
            top: 0;
            left: 0;
            bottom: 0;
            width: 5px; /* 5px for the mouse cursor update size */
            border-left: 1px solid @grey-3;
            cursor: col-resize;
          }
          .crop .crop-right-line {
            top: 0;
            right: 0;
            bottom: 0;
            width: 5px; /* 5px for the mouse cursor update size */
            border-right: 1px solid @grey-3;
            cursor: col-resize;
          }
          .crop .crop-corner {
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 2px;
            border: 1px solid #808080;
            background: #FFF;
            opacity: 0;
            transition: all 0.25s;
          }
          .crop .crop-top-left-corner {
            top: -3px;
            left: -3px;
            cursor: nw-resize;
          }
          .crop .crop-top-right-corner {
            top: -3px;
            right: -3px;
            cursor: ne-resize;
          }
          .crop .crop-bottom-left-corner {
            bottom: -3px;
            left: -3px;
            cursor: sw-resize;
          }
          .crop .crop-bottom-right-corner {
            bottom: -3px;
            right: -3px;
            cursor: se-resize;
          }
          .crop:hover .crop-corner {
            opacity: 1;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// StaffingHeader.vue?0e1ac6df